import { useEffect } from "react";
import { track } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { useBooking } from "@/context/BookingContext";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";
import { MapPin, Phone, Clock, Navigation, Mail, CalendarCheck } from "lucide-react";

export default function Contatti() {
  const { settings } = useSettings();
  const { open: openBooking } = useBooking();
  useEffect(() => { track("page_view", "contatti"); }, []);
  const tel = (settings.phone_primary || "").replace(/\s/g, "");
  const tel2 = (settings.phone_secondary || "").replace(/\s/g, "");

  return (
    <div>
      <SEO title="Contatti" description="Ristorante Masetti, Via Gesso 70, 40069 Zola Predosa (BO). Telefono, orari, mappa e indicazioni stradali." />
      <div className="bg-oak-dark text-cream py-14 text-center">
        <p className="font-accent italic text-brass text-lg">Ti aspettiamo</p>
        <h1 className="font-serif text-4xl sm:text-5xl">Contatti</h1>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-2 gap-10">
        <div>
          <h2 className="font-serif text-2xl text-bordeaux mb-4">Ristorante Masetti</h2>
          <div className="space-y-4 text-oak/80">
            <p className="flex items-start gap-3"><MapPin className="w-5 h-5 text-brass mt-0.5" /><span>{settings.address}<br />{settings.city}</span></p>
            {settings.phone_primary && <p className="flex items-center gap-3"><Phone className="w-5 h-5 text-brass" /><a href={`tel:${tel}`} onClick={() => track("call_click", "contatti")} className="hover:text-bordeaux">{settings.phone_primary}{settings.phone_primary_name ? ` · ${settings.phone_primary_name}` : ""}</a></p>}
            {settings.phone_secondary && <p className="flex items-center gap-3"><Phone className="w-5 h-5 text-brass" /><a href={`tel:${tel2}`} onClick={() => track("call_click", "contatti-2")} className="hover:text-bordeaux">{settings.phone_secondary}{settings.phone_secondary_name ? ` · ${settings.phone_secondary_name}` : ""}</a></p>}
            {settings.email && <p className="flex items-center gap-3"><Mail className="w-5 h-5 text-brass" /><a href={`mailto:${settings.email}`} className="hover:text-bordeaux">{settings.email}</a></p>}
          </div>

          <div className="mt-6">
            <h3 className="font-serif text-lg text-oak flex items-center gap-2 mb-2"><Clock className="w-4 h-4 text-brass" />Orari di apertura</h3>
            <div className="text-sm">
              {(settings.hours || []).map((h) => (
                <div key={h.day} className="flex justify-between border-b border-brass/10 py-1"><span className="text-oak/60">{h.day}</span><span className="text-oak">{h.value}</span></div>
              ))}
            </div>
          </div>

          <div className="flex flex-wrap gap-3 mt-6">
            <Button onClick={() => openBooking("contatti")} className="bg-bordeaux hover:bg-bordeaux-dark text-cream rounded-full" data-testid="contatti-prenota"><CalendarCheck className="w-4 h-4 mr-2" />Prenota</Button>
            {tel && <a href={`tel:${tel}`} onClick={() => track("call_click", "contatti-btn")}><Button variant="outline" className="border-bordeaux text-bordeaux hover:bg-bordeaux hover:text-cream rounded-full" data-testid="contatti-chiama"><Phone className="w-4 h-4 mr-2" />Chiama</Button></a>}
            {settings.google_maps_url && <a href={settings.google_maps_url} target="_blank" rel="noreferrer" onClick={() => track("maps_click", "contatti")}><Button variant="outline" className="border-bordeaux text-bordeaux hover:bg-bordeaux hover:text-cream rounded-full" data-testid="contatti-indicazioni"><Navigation className="w-4 h-4 mr-2" />Indicazioni</Button></a>}
          </div>
        </div>

        <div className="rounded-2xl overflow-hidden border border-brass/20 min-h-[360px]">
          {settings.maps_embed && <iframe title="Mappa Ristorante Masetti" src={settings.maps_embed} className="w-full h-full min-h-[360px]" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />}
        </div>
      </div>
    </div>
  );
}
